// extracted by mini-css-extract-plugin
export default {"root":"PhoneFloatingBox-root_ycZd4","paragraph":"PhoneFloatingBox-paragraph_rY9CV","closeBtn":"PhoneFloatingBox-closeBtn_RBjzf"};